import { useBeeswaxDevices } from "@/modules/Beeswax/beeswax.hook";
import { LINE_ITEM_TYPE } from "@/modules/Campaign/GeneralCampaign/DetailCampaign/data";
import {
  SubModule,
  SubModuleCommonProps,
} from "@/modules/Presets/TargetingExpression/targetingExpression.interface";
import { TName } from "@/types";
import { formateDataForCustomSelect } from "@/utils/helpers";
import { Box } from "@mui/material";
import { FieldValues, useWatch } from "react-hook-form";
import SelectModuleWithType from "../SelectModuleWithType";
const moduleName = "platform";
export default function Platform<
  T extends FieldValues,
  U extends SubModule = "PLATFORM"
>({
  control,
  errors,
  setValue,
  getValues,
  parentName,
  devices,
  devicesLoading,
  isEdit,
}: PlatformProps<T, U>) {
  const {
    data: localDevices,
    isLoading: localDevicesLoading,
    isFetching: localDevicesFetching,
  } = useBeeswaxDevices({ options: { enabled: !devicesLoading && !devices } });
  const lineItemType = useWatch({
    control,
    name: "type" as TName<T>
  })

  devices = isEdit && devices ? devices : localDevices;
  devicesLoading =
    isEdit && (devices || devicesLoading)
      ? devicesLoading
      : devicesLoading && localDevicesLoading && localDevicesFetching;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100%",
        overflow: "auto",
        padding: 2,
      }}
    >
      <SelectModuleWithType<T>
        itemList={formateDataForCustomSelect(devices?.results, "name", "id")}
        control={control}
        errors={errors}
        name={`${parentName}.${moduleName}.device_type`}
        label="Device Type"
        setValue={setValue}
        getValues={getValues}
        loading={devicesLoading}
        isReadOnly={lineItemType === LINE_ITEM_TYPE.CTV}
      />
    </Box>
  );
}

type PlatformProps<T extends FieldValues, U> = U extends "PLATFORM"
  ? Platform<T>
  : never;
interface Platform<T extends FieldValues> extends SubModuleCommonProps<T> {
  devices: any;
  devicesLoading: boolean;
}
